export const MENH_GIA = [
    { label: "Loại 500,000đ", value: 500000 },
    { label: "Loại 200,000đ", value: 200000 },
    { label: "Loại 100,000đ", value: 100000 },
    { label: "Loại 50,000đ", value: 50000 },
    { label: "Loại 20,000đ", value: 20000 },
    { label: "Loại 10,000đ", value: 10000 },
    { label: "Loại 5,000đ", value: 5000 },
    { label: "Loại 2,000đ", value: 2000 },
    { label: "Loại 1,000đ", value: 1000 },
    { label: "Loại 500đ", value: 500 },
];

export const parseMenhGia = (menhGiaString) => {
    if (typeof menhGiaString !== 'string') return 0;
    const cleanedString = menhGiaString.replace(/[^\d,]/g, '').replace(/,/g, '');
    return parseInt(cleanedString, 10) || 0;
};